export const accountStorageKey = 'PORTAL_ACCOUNT';
export const currentTenantStorageKey = 'PORTAL_CURRENT_TENANT';
export const currentGravatarStorageKey = 'PORTAL_GRAVATAR';
export const shellDebug = 'SHELL_DEBUG';
